"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const entityRequest_1 = require("../entityRequest");
const queryBuilder_1 = __importDefault(require("../queryBuilder"));
const communities = (creds, Ienvironment, fetchExecutor) => ({
    byIds: (params) => (0, entityRequest_1.requestGet)(`v1/communities/${params.toString()}?detail_level=FULL`, creds, "Community", Ienvironment, fetchExecutor),
    searchSummary: (params) => (0, entityRequest_1.requestGet)(`v1/communities/?${(0, queryBuilder_1.default)(Object.assign(Object.assign({}, params), { detailLevel: "SUMMARY" }))}`, creds, "MHBOListing", Ienvironment, fetchExecutor),
    searchSummaryV2: (params) => (0, entityRequest_1.requestGetSummary)(`v2/search/?${(0, queryBuilder_1.default)(Object.assign(Object.assign({}, params), { detailLevel: "SUMMARY" }))}`, creds, Ienvironment, fetchExecutor),
});
exports.default = communities;
